import React  from 'react';
import PropTypes from 'prop-types';

import DurationInput from "core/gd-ui/duration-input/duration";
import DurationCalendarDaysField from "../duration-calendar-days";

export default function DurationCalendarDaysInList(props) {

    const value = DurationCalendarDaysField.getValue(props.item);

    return (
        <DurationInput className="gd-field-duration list"
                       type="list"
                       value={value}
                       placeholder="Duration"
                       onFocus={props.onFocus}
                       onBlur={props.onBlur}
                       disabled={props.disabled}
                       onChange={props.onChange}/>
    );
}

DurationCalendarDaysInList.propTypes = {
    item: PropTypes.object,
    disabled: PropTypes.bool,

    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func
};